import getLanguageByPath from './locale/getLanguageByPath';
import dayjs from 'dayjs';

export default function formatLocaleDate(date, locale = getLanguageByPath()) {
    let formatStr = '';
    // //console.log(date);

    switch (locale) {
        case 'en':
            formatStr = 'MM/DD/YYYY';
            break;
        case 'es':
        case 'pt':
        case 'fr':
        case 'th':
            formatStr = 'DD/MM/YYYY';
            break;
        case 'de':
        case 'ru':
            formatStr = 'DD.MM.YYYY';
            break;
        default:
            formatStr = 'YYYY/MM/DD';
            break;
    }

    return dayjs(date * 1000).format(formatStr);
}
